import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// components
import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    FormGroup,
    Input,
    Button,
    CardBody,
    Spinner
} from "reactstrap";
import Select from 'react-select'
import MaterialTable from "material-table";
import { Map, Marker, Tooltip, GeoJSON } from 'react-leaflet'
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';

// style
import "../../../assets/css/map.css";
import "../../../assets/css/loading.css";

// helpers
import { icon_ecoponto_azul, icon_planotrabalho_azul, icon_avulso_azul, icon_ecoponto_cinza, icon_planotrabalho_cinza, icon_avulso_cinza } from "../../../helpers/icons";

// services
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";


export default function PlanosColetaForm({ history, handleReturn, item }) {
    const session = getSessionCookie();

    const { register, handleSubmit, errors, setError, clearErrors, setValue, getValues } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);

    const [mapaSatelite, setmapaSatelite] = useState(false);

    // Concessionária
    const [optionsConcessionaria, setOptionsConcessionaria] = useState([]);
    const [concessionaria, setConcessionaria] = useState("");
    const [registraDestinacao, setRegistraDestinacao] = useState();
    const loadOptionsConcessionaria = () => {
        api_GET(`concessionaria`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOptionsConcessionaria(result.data);
                if (session.concessionariaId != null && item == null)
                    setConcessionaria(result.data.filter(f => f.concessionariaId == session.concessionariaId)[0]);
            }
        });
    }
    const handleConcessionaria = event => {
        let value = event;
        setConcessionaria(value);
        clearErrors("concessionaria");
    }
    useEffect(() => {
        loadOptionsModalidadesColeta();
    }, [concessionaria]);

    // Modalidade Serviço
    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = useState([]);
    const [modalidadeColeta, setModalidadeColeta] = useState(null);
    const loadOptionsModalidadesColeta = () => {
        if (concessionaria == "")
            return;
        api_GET(`modalidadeColeta/GetByConcessionaria/${concessionaria.concessionariaId}`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setoptionsModalidadesColeta(result.data);
            }
        });
    }
    const handleModalidadesColeta = event => {
        let value = event;
        setModalidadeColeta(value);
        clearErrors("modalidadeColeta");
    }
    useEffect(() => {
        if (modalidadeColeta != null) {
            if (modalidadeColeta.registraDestinacao == "Sim")
                setRegistraDestinacao("Sim")
            else
                setRegistraDestinacao("Não")
            if (modalidadeColeta.registraDestinacao == "Apenas Descarregamento")
                setRegistraDestinacao("Apenas Descarregamento")
        }
        set_list_table([]);
        setPontoColetaAdd(null);
        loadOptionsDelimitacaoSetor();
        loadOptionsVeiculo();
        loadOptionsPontosColeta();
    }, [modalidadeColeta]);

    // Delimitação do Setor
    const [optionsDelimitacaoSetor, setoptionsDelimitacaoSetor] = useState([]);
    const [delimitacaoSetor, setdelimitacaoSetor] = useState(null);
    const loadOptionsDelimitacaoSetor = () => {
        setshowLoading(true);
        setoptionsDelimitacaoSetor(null);
        setdelimitacaoSetor(null);
        if (modalidadeColeta == null)
            return;
        api_GET(`modalidadeColeta/GetListDelimitacaoGeograficaSetor/${modalidadeColeta.modalidadeColetaId}`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Não foi possível consultar as delimitações geográficas", result.message, 'error', null);
            }
            else {
                setoptionsDelimitacaoSetor(result.data);
                if (item != null)
                    setdelimitacaoSetor(item.delimitacaoGeograficaSetor);
            }
        });
    }
    const handleDelimitacaoSetor = event => {
        let value = event;
        setdelimitacaoSetor(value);
        clearErrors("delimitacaoSetor");
    }
    useEffect(() => {
        loadOptionsPontosColeta();

        if (delimitacaoSetor != null) {
            var newlist = list_table.filter(f => f.delimitacaoGeograficaSetorId == delimitacaoSetor.delimitacaoGeograficaSetorId || f.delimitacaoGeograficaSetorId == null);
            set_list_table(newlist)
        }
    }, [delimitacaoSetor]);

    // Regional = Divisão Administrativa
    const [optionsRegional, setOptionsRegional] = useState([]);
    const [regional, setRegional] = useState([]);
    const loadOptionsRegional = () => {
        if (localStorage.getItem("regionais") != null) {
            setOptionsRegional(JSON.parse(localStorage.getItem("regionais")));
        }
        else {
            api_GET(`regional`).then(result => {
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    setOptionsRegional(result.data);
                }
            });
        }
    }
    const handleRegional = event => {
        let value = event;
        setRegional(value);
        clearErrors("regional");
    }
    useEffect(() => {
        loadOptionsPontosColeta();
    }, [regional]);

    // Veículo
    const [optionsVeiculo, setOptionsVeiculo] = useState([]);
    const [veiculo, setVeiculo] = useState(null);
    const loadOptionsVeiculo = () => {
        if (concessionaria == null || modalidadeColeta == null)
            return;
        api_GET(`veiculo/GetAtivoByConcessionariaModalidadeColeta/${concessionaria.concessionariaId}/${modalidadeColeta.modalidadeColetaId}`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOptionsVeiculo(result.data);
            }
        });
    }
    const handleVeiculoChange = event => {
        let value = event;
        setVeiculo(value);
        clearErrors("veiculo");
    }

    // Destino
    const [optionsDestino, setOptionsDestino] = useState([]);
    const [destino, setDestino] = useState(null);
    const loadOptionsDestino = () => {
        api_GET(`destino/GetAtivos`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOptionsDestino(result.data);
                if (item != null && item.destino != null)
                    setDestino(item.destino);
            }
        });
    }
    const handleDestinoChange = event => {
        let value = event;
        setDestino(value);
        if (registraDestinacao == "Sim" || registraDestinacao == "Não" || registraDestinacao == "Apenas Descarregamento")
            clearErrors("destino");
    }

    // Status
    const [status, setStatus] = useState("Ativo");
    //options
    const [options_status, set_options_status] = useState([
        { value: "Ativo", label: "Ativo" },
        { value: "Inativo", label: "Inativo" }
    ]);
    const handleStatus = (value) => {
        clearErrors("status");
        setStatus(value);
    }

    // Pontos de Coleta
    const [showPontosColetaAdd, setshowPontosColetaAdd] = useState(false);
    const [pontoColetaAdd, setPontoColetaAdd] = useState(null);
    const [optionsPontosColeta, setOptionsPontosColeta] = useState([]);
    const loadOptionsPontosColeta = () => {
        if (regional == null || (regional != null && regional.length == 0) || modalidadeColeta == null) {
            setOptionsPontosColeta([]);
            return;
        }

        let regionais = [];
        regional.map(item => {
            regionais.push(item.regionalId);
        })
        let json_post = {
            setorColetaId: item == null ? null : item.setorColetaId,
            regionais: regionais,
            modalidadeColetaId: modalidadeColeta.modalidadeColetaId,
            delimitacaoGeograficaSetorId: delimitacaoSetor == null ? null : delimitacaoSetor.delimitacaoGeograficaSetorId
        }
        setshowLoading(true);
        api_POST(`PontoColeta/GetListByCadastroSetor`, json_post).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let newoptions = [];
                for (var i in result.data) {
                    if (list_table.filter(f => f.pontoColetaId == result.data[i].pontoColetaId).length == 0)
                        newoptions.push(result.data[i]);
                }

                setOptionsPontosColeta(newoptions);
            }
        });
    }
    const handleMessageAddPontoColetaMap = (ponto) => {
        setPontoColetaAdd(ponto);
        showQuestion("Deseja adicionar o Local ao setor?", ponto.logradouro + "," + ponto.numeroLogradouro, "question", function (result) {
            if (result)
                handleAddPontoColeta(ponto);
        })
    }

    const [centerMap, setcenterMap] = useState([-3.755019499914185, -38.5860013961792]);

    // Lista de Pontos Adicionaidos
    const [list_table, set_list_table] = useState([])
    const [list_loading, set_list_loading] = useState(false);

    const handleAddPontoColeta = (ponto) => {
        if (pontoColetaAdd == null && ponto == null) {
            showMessage("Aviso", "Selecione um local de execução para adicionar", 'warning', null);
            return;
        }

        if (ponto == null)
            ponto = pontoColetaAdd;

        ponto.sequencia = list_table.length + 1;

        let new_list = list_table;
        new_list.push(ponto);
        set_list_table(new_list);

        let newoptions = [];
        for (var i in optionsPontosColeta) {
            if (new_list.filter(f => f.pontoColetaId == optionsPontosColeta[i].pontoColetaId).length == 0)
                newoptions.push(optionsPontosColeta[i]);
        }

        setPontoColetaAdd(null);
        setOptionsPontosColeta(newoptions);
        setcenterMap([ponto.latitude, ponto.longitude]);
    }
    const handleAddAllPontosColeta = () => {
        let new_list = list_table;
        let sequencia = list_table.length + 1;
        for (var i in optionsPontosColeta) {
            if (new_list.filter(f => f.pontoColetaId == optionsPontosColeta[i].pontoColetaId).length == 0) {
                optionsPontosColeta[i].sequencia = sequencia;
                new_list.push(optionsPontosColeta[i]);
                sequencia = sequencia + 1;
            }
        }
        set_list_table(new_list);
        setPontoColetaAdd(null);
        setOptionsPontosColeta([]);
        if (new_list.lenght > 0)
            setcenterMap([new_list[0].latitude, new_list[0].longitude]);
    }
    const Remove = (event, rowData) => {
        let newoptions = [];
        optionsPontosColeta.map(m => {
            newoptions.push(m);
        });
        newoptions.push(rowData);
        setOptionsPontosColeta(newoptions)

        let new_list = list_table.filter(f => f.pontoColetaId != rowData.pontoColetaId);
        set_list_table(new_list);
    }
    const handleSequenciaChange = (value, rowData) => {
        let new_list = [];
        list_table.map(m => {
            if (m.pontoColetaId == rowData.pontoColetaId)
                m.sequencia = value == "" ? 0 : value;

            new_list.push(m);
        });

        set_list_table(new_list);
    }

    // Submit e Load de informações
    const onSubmit = (data) => {
        if (modalidadeColeta == null) {
            setError("modalidadeColeta");
            return;
        }
        if (optionsDelimitacaoSetor.length > 0 && delimitacaoSetor == null) {
            setError("delimitacaoSetor");
            return;
        }

        if (veiculo == null) {
            setError("veiculo")
            return;
        }

        if ((registraDestinacao == "Sim" || registraDestinacao == "Apenas Descarregamento") && destino === null) {
            setError("destino");
            return;
        }

        if (status == "") {
            setError("status");
            return;
        }

        if (list_table.lenght == 0) {
            showMessage("Aviso", "Informe a lista de locais de execução", 'warning', null);
            return;
        }

        let pontosColeta = [];
        list_table.map(item => {
            pontosColeta.push({
                setorColetaId: item == null ? 0 : item.setorColetaId,
                pontoColetaId: item.pontoColetaId,
                sequencia: item.sequencia
            });
        })

        let regionais = [];
        regional.map(item => {
            regionais.push({
                setorColetaId: item == null ? 0 : item.setorColetaId,
                regionalId: item.regionalId
            });
        })

        let json_submit = {
            setorColetaId: item == null ? 0 : item.setorColetaId,
            descricao: data.descricao,
            modalidadeColetaId: modalidadeColeta.modalidadeColetaId,
            veiculoId: veiculo.veiculoId,
            setorColetaRegional: regionais,
            setorColetaPontoColeta: pontosColeta,
            delimitacaoGeograficaSetorId: delimitacaoSetor == null ? null : delimitacaoSetor.delimitacaoGeograficaSetorId,
            destinoId: registraDestinacao == "Sim" || registraDestinacao == "Apenas Descarregamento" ? destino.destinoId : null,
            status: status,
            usuarioCadastroId: session.usuarioId,
            usuarioAtualizacaoId: session.usuarioId
        }

        setshowLoading(true);
        if (json_submit.setorColetaId == 0) {
            api_POST('setorColeta', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        handleReturn(result.data);
                    });
                }
            });
        }
        else {
            api_PUT('setorColeta', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        handleReturn(result.data);
                    });
                }
            });
        }
    };
    const loadPontosColetaItem = () => {
        set_list_loading(true);

        api_GET(`PontoColeta/GetListBySetorId/${item.setorColetaId}`).then(result => {
            set_list_loading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_list_table(result.data);
                if (result.data.length > 0)
                    setcenterMap([result.data[0].latitude, result.data[0].longitude]);
            }
        });
    }

    const [disableAll, setdisableAll] = useState(false);
    useEffect(() => {
        loadOptionsDestino();
        setshowLoading(true);
        loadOptionsConcessionaria();
        loadOptionsRegional();
        setRegistraDestinacao("Não");
        if (item != null) {
            setValue("descricao", item.descricao);
            setConcessionaria(item.veiculo.concessionaria);
            setModalidadeColeta(item.modalidadeColeta);
            setVeiculo(item.veiculo);
            setStatus(item.status);

            let regionais = [];
            item.setorColetaRegional.map(m => {
                regionais.push(m.regional);
            });
            setRegional(regionais);
            loadPontosColetaItem();

            if (session.perfil != "Gestor" && session.perfil != "Master")
                setdisableAll(true);
        }
        else {
            setshowLoading(false);
        }
    }, [item]);

    const columnsProp = [
        { title: 'Endereço', field: "logradouro", render: (rowData) => rowData.logradouro },
        { title: 'Número', field: "numeroLogradouro" },
        { title: 'Bairro', field: "bairro" },
        { title: 'Identificação', field: "identificacao" },
        { title: 'Área Operacional', field: "territorio" },
        { title: 'Divisão Administrativa', field: "regional" },
        { title: 'Frequência', field: "frequencia" },
        {
            title: 'Sequência', field: "sequencia",
            render: (rowData) =>
                rowData && (
                    <Input type="number" onBlur={(e) => handleSequenciaChange(e.target.value, rowData)} defaultValue={rowData.sequencia} />
                )
        }
    ]

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label style={{ marginRight: "20px" }}>Carregando...</label>
                        <Spinner size="sm" color="info" />
                    </div>
                </div>
            }
            <Row>
                <Container fluid>
                    <Card className="shadow">

                        <CardHeader className="border-0">
                            <strong> Plano de Trabalho</strong>
                        </CardHeader>
                        <CardBody>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    {session.concessionariaId == null &&
                                        <Col md="6" lg="6">
                                            <FormGroup>
                                                <label className="form-control-label" >
                                                    * Concessionária
                                                </label>
                                                <Select
                                                    options={optionsConcessionaria}
                                                    name="concessionaria"
                                                    getOptionLabel={({ identificacao }) => identificacao}
                                                    getOptionValue={({ concessionariaId }) => concessionariaId}
                                                    onChange={(value) => { handleConcessionaria(value) }}
                                                    value={optionsConcessionaria.find(obj => obj.concessionariaId === concessionaria.concessionariaId)}
                                                    placeholder="Selecione"
                                                    isDisabled={disableAll ? "yes" : ""}
                                                />
                                                {errors.concessionaria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                    }
                                    <Col md="6" lg="6">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                * Identificação
                                            </label>
                                            <Input
                                                name="descricao"
                                                placeholder="Descrição"
                                                type="text"
                                                innerRef={register({ required: true })}
                                                disabled={disableAll ? "disabled" : ""}
                                            />
                                            {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="6">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                * Modalidade de Serviço
                                            </label>
                                            <Select
                                                name="modalidadeColeta"
                                                options={optionsModalidadesColeta}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                                                onChange={(value) => { handleModalidadesColeta(value) }}
                                                value={modalidadeColeta != null && optionsModalidadesColeta.find(obj => obj.modalidadeColetaId === modalidadeColeta.modalidadeColetaId)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.modalidadeColeta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="6">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                Delimitação Geográfica do Setor
                                            </label>
                                            <Select
                                                name="delimitacaoSetor"
                                                options={optionsDelimitacaoSetor}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ delimitacaoGeograficaSetorId }) => delimitacaoGeograficaSetorId}
                                                onChange={(value) => { handleDelimitacaoSetor(value) }}
                                                value={(delimitacaoSetor != null && optionsDelimitacaoSetor != null) && optionsDelimitacaoSetor.find(obj => obj.delimitacaoGeograficaSetorId === delimitacaoSetor.delimitacaoGeograficaSetorId)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.delimitacaoSetor && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    {(registraDestinacao == "Sim" || registraDestinacao == "Apenas Descarregamento") && <Col md="6" lg="4">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                * Destino
                                            </label>
                                            <Select
                                                name="destino"
                                                options={optionsDestino}
                                                getOptionLabel={({ identificacao }) => identificacao}
                                                getOptionValue={({ destinoId }) => destinoId}
                                                onChange={(e) => { handleDestinoChange(e) }}
                                                value={destino != null && optionsDestino.find(obj => obj.destinoId === destino.destinoId)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.destino && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>}
                                    <Col md="12" lg="12">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                * Divisão Administrativa
                                            </label>
                                            <Select
                                                options={optionsRegional}
                                                name="regional"
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ regionalId }) => regionalId}
                                                onChange={(value) => { handleRegional(value || []) }}
                                                value={optionsRegional.filter(({ regionalId }) => regional != null && regional.filter(f => f.regionalId == regionalId).length > 0)}
                                                placeholder="Selecione"
                                                isMulti="true"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.regional && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                * Recurso
                                            </label>
                                            <Select
                                                name="veiculo"
                                                options={optionsVeiculo}
                                                getOptionLabel={({ placa }) => placa}
                                                getOptionValue={({ veiculoId }) => veiculoId}
                                                onChange={(value) => { handleVeiculoChange(value) }}
                                                value={veiculo != null && optionsVeiculo.find(obj => obj.veiculoId === veiculo.veiculoId)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                            {errors.veiculo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" lg="4">
                                        <label className="form-control-label" htmlFor="input-address" >
                                            * Status
                                        </label>
                                        <Select
                                            name="status"
                                            options={options_status}
                                            onChange={(e) => { handleStatus(e.value) }}
                                            value={options_status.find(obj => obj.value === status)}
                                            placeholder="Selecione"
                                            isDisabled={disableAll ? "yes" : ""}
                                        />
                                        {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </Col>
                                    <Col md="8">
                                        <FormGroup>
                                            <label className="form-control-label" htmlFor="input-address" >
                                                * Locais de Execução
                                            </label>
                                            <Select
                                                name="pontoColeta"
                                                options={optionsPontosColeta}
                                                getOptionLabel={({ descricao }) => descricao}
                                                getOptionValue={({ pontoColetaId }) => pontoColetaId}
                                                onChange={(value) => { setPontoColetaAdd(value) }}
                                                value={pontoColetaAdd != null && optionsPontosColeta.find(obj => obj.pontoColetaId == pontoColetaAdd.pontoColetaId)}
                                                placeholder="Selecione"
                                                isDisabled={disableAll ? "yes" : ""}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4">
                                        <br />
                                        <Button outline color="info" type="button" onClick={() => handleAddPontoColeta()}>Adicionar</Button>
                                    </Col>
                                    <Col md="12">
                                        <Button color="secondary" className="btn-sm" type="button" onClick={() => handleAddAllPontosColeta()}>Adicionar Todos os Locais de Execução</Button>
                                    </Col>
                                </Row>
                                <Row className="mt-4 mb-4">
                                    <Col md="12">
                                        <MaterialTable
                                            title="Lista de Locais de Execução"
                                            columns={columnsProp}
                                            data={list_table}
                                            isLoading={list_loading}
                                            options={{ ...table_style, pageSizeOptions: [5, 10, list_table.length], headerStyle: { zIndex: 0 } }}
                                            actions={[
                                                {
                                                    icon: 'delete',
                                                    tooltip: 'Remover',
                                                    onClick: (event, rowData) => Remove(event, rowData)
                                                }
                                            ]}
                                            localization={table_translate}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col md="6">
                                        <h4>Mapa de Locais de Execução</h4>
                                    </Col>
                                    <Col md="6" className="text-right">
                                        <Button color="info"
                                            outline
                                            className="btn-sm"
                                            type="button"
                                            onClick={() => setmapaSatelite(!mapaSatelite)}
                                        >
                                            {mapaSatelite ? "Mapa" : "Satélite"}
                                        </Button>
                                    </Col>
                                    <Col md="12">
                                        <div id="map">
                                            <Map center={centerMap} zoom={16}>
                                                {mapaSatelite &&
                                                    <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: 'AIzaSyCA4LC5FmVmZ84YbtuQT87xlLpYKcseJms' }}
                                                        type={'satellite'}
                                                    />
                                                }
                                                {!mapaSatelite &&
                                                    <ReactLeafletGoogleLayer googleMapsLoaderConf={{ KEY: 'AIzaSyCA4LC5FmVmZ84YbtuQT87xlLpYKcseJms' }}
                                                        type={'roadmap'}
                                                    />
                                                }
                                                {(list_table != null) && list_table.map(item => (
                                                    <Marker
                                                        key={item.pontoColetaId}
                                                        position={[item.latitude, item.longitude]}
                                                        draggable={false}
                                                        icon={item.categoria == "Ecoponto" ? icon_ecoponto_azul : (item.categoria == "Plano de Trabalho" ? icon_planotrabalho_azul : icon_avulso_azul)}>
                                                        <Tooltip direction='center' offset={[0, 0]} opacity={1} permanent>
                                                            <span>{item.sequencia}</span>
                                                        </Tooltip>
                                                    </Marker>
                                                ))}
                                                {delimitacaoSetor != null &&
                                                    <GeoJSON
                                                        key={delimitacaoSetor.delimitacaoGeograficaSetorId}
                                                        data={JSON.parse(delimitacaoSetor.geoJson)}
                                                    />
                                                }
                                                {(showPontosColetaAdd && optionsPontosColeta != null) && optionsPontosColeta.map(item => (
                                                    <Marker
                                                        onClick={() => handleMessageAddPontoColetaMap(item)}
                                                        key={item.pontoColetaId}
                                                        position={[item.latitude, item.longitude]}
                                                        draggable={false}
                                                        icon={item.categoria == "Ecoponto" ? icon_ecoponto_cinza : (item.categoria == "Plano de Trabalho" ? icon_planotrabalho_cinza : icon_avulso_cinza)}>
                                                    </Marker>
                                                ))}
                                            </Map>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" lg="12">
                                        <FormGroup check>
                                            <label check className="form-control-label">
                                                <Input
                                                    name="pontos_cadastrados"
                                                    type="checkbox"
                                                    onChange={(e) => setshowPontosColetaAdd(e.target.checked)}
                                                    innerRef={register()}
                                                    disabled={disableAll ? "disabled" : ""}
                                                />
                                                Visualizar Locais de Execução Cadastrados
                                            </label>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center">
                                        <label className="form-control-label"></label>
                                        <FormGroup>
                                            <Button color="warning" type="button" onClick={() => { window.location.reload() }}>Voltar</Button>
                                            {!disableAll && <Button color="success">Salvar</Button>}
                                        </FormGroup>
                                    </Col>
                                </Row>

                            </form>
                        </CardBody>
                    </Card>
                </Container>
            </Row>
        </>
    );
}
